/**
 *
 * AdministratorList
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"
import { Spin, Table } from "antd"
import pencilBlue from "../../images/pencil-blue.svg"
import removeIcon from "../../images/remove_icon.svg"
import columns from "./columns"
/* eslint-disable react/prefer-stateless-function */
class AdministratorList extends React.Component {
  render() {
    const { users, users_loading, company_id, loading, disabled } = this.props
    if (users.length === 0) {
      return <div />
    }
    return (
      <div className="AdministratorListComponent">
        {users_loading ? (
          <div className="loadingSpin">
            <Spin size="large" />
          </div>
        ) : (
          <Table
            className="container-usermanagement__table"
            rowKey={(record) => record.id}
            dataSource={Array.isArray(users) ? users : []}
            columns={columns(
              users,
              this.props.usersSASwitch,
              this.props.userDelete,
              this.props.userSelected,
              company_id,
              loading,
              disabled
            )}
            loading={this.props.isLoadingListUsers}
            pagination={{
              pageSizeOptions: ["15", "25", "50", "100"],
              showSizeChanger: true,
              size: "default",
              defaultPageSize: 15,
            }}
          />
        )}
      </div>
    )
  }
}

AdministratorList.propTypes = {}

export default AdministratorList
